import { Arrange, Container, Icon, SvgZap, Text } from '@loomhq/lens';
import React from 'react';

import { CONTENT_LIMIT_BANNER_CLICKED } from 'constants/events';
import { WORKSPACE_PLAN_BUSINESS } from 'constants/workspacePlans';
import { UPGRADE_TYPES } from 'constants/workspaceUpgradeRequests';
import { getUpgradeType } from 'utilities/upgrades';

import {
  useGetMemberVideoLimits,
  useGetSelectedWorkspace,
} from 'hooks/workspace';

import UpgradeButton from 'components/upgrade-button';

import './styles.less';

const MemberVideoLimitBanner = () => {
  const memberLimits = useGetMemberVideoLimits();
  const selectedWorkspace = useGetSelectedWorkspace();
  const upgradeType = getUpgradeType({
    selectedWorkspace,
    minPlanForFeature: WORKSPACE_PLAN_BUSINESS,
  });

  return memberLimits.exceededLimit ? (
    <div className="banner">
      <Container
        width="100%"
        backgroundColor="upgrade"
        paddingTop="medium"
        paddingBottom="medium"
        paddingLeft="large"
        paddingRight="large"
        radius="medium"
      >
        <Arrange align="center" justifyContent="space-between">
          <Arrange align="center" gap="small" justifyContent="center">
            <Icon icon={<SvgZap />} />
            <Container>
              <Text fontWeight="bold" isInline>
                You’ve reached your limit of {memberLimits.limit} videos in this
                Workspace.{' '}
              </Text>
              <Text isInline>
                {upgradeType === UPGRADE_TYPES.ROLE
                  ? 'Request a role upgrade for unlimited videos.'
                  : 'Upgrade your plan for unlimited videos with no restriction on recording time.'}
              </Text>
            </Container>
          </Arrange>
          <UpgradeButton
            analyticsEvent={CONTENT_LIMIT_BANNER_CLICKED}
            defaultRoleText="Request role upgrade"
            variant="neutral"
            hideIcon
            hideTooltip
          />
        </Arrange>
      </Container>
    </div>
  ) : null;
};

export default MemberVideoLimitBanner;
